<template>
  <v-container fluid>
    <v-row class="px-8 mb-3 mt-1">
      <v-col offset="3" cols="9">
        <v-row>
          <v-col offset="7" class="pt-0"> </v-col>
          <v-col cols="4" class="pt-0">
            <v-text-field
              label="Speciality"
              hide-details
              outlined
              dense
              @keydown="checkEnter"
              v-model="searchByTitle"
            >
              <template v-slot:append>
                <v-btn
                  depressed
                  color="primary"
                  class="topBar-search ma-0"
                  @click="getMajorByTitle"
                >
                  <v-icon v-text="'fas fa-search'"></v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-tabs :value="tab" @change="changedTab" grow>
      <v-tab v-for="tabSelect in tabList" :key="tabSelect">
        {{ tabSelect }}
      </v-tab>
    </v-tabs>
    <TableDefault
      :headers="headers"
      :items="items"
      :totalPage="totalPage"
      :totalItem="totalItem"
      :limit="limit"
      :currentPage="currentPage"
      :content="content"
      @getContent="getContent"
      @edit="getMajorEdit"
      @remove="remove"
      @changePage="changePage"
      @changeItemPerPage="changeItemPerPage"
    />
  </v-container>
</template>

<script>
import TableDefault from "@/components/tables/TableDefault";
import majorService from "@/services/major";
import {mapState} from "vuex";
export default {
  name: "Major",
  components: { TableDefault },
  props: {
    tabList: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    tab: 1,
    content: '',
    headers: [
      {
        text: "Niveau",
        field: "degreeType.name"
      },
      {
        text: "Name",
        field: "name",
      },
      {
        text: "Active",
        field: "active",
        checkbox: true,
        disable: true,
        width: "50px"
      },
      {
        text: "Action",
        action: true,
        hiddenRemove: true,
        width: "130px"
      }
    ],
    items: [],
    topics: [],
    totalPage: 1,
    totalItem: 0,
    currentPage: 1,
    searchByTitle: "",
    searchByDegreeType: 1,
    limit: 50
  }),
  computed: {
    ...mapState({
      form: state => state.major.major
    })
  },
  created() {
    this.getMajor();
  },
  methods: {
    changedTab(tab) {
      this.$emit("changeTab", tab);
    },
    checkEnter(event) {
      if (event.code === "Enter") {
        this.getMajor();
      }
    },
    changePage(page) {
      this.currentPage = page;
      this.getMajor();
    },
    changeItemPerPage(limit) {
      this.limit = limit;
      this.getMajor();
    },
    create() {
      this.$store.dispatch("resetMajor");
      this.$router.push({ name: "ResumeCreate", query: { tab: 1 } });
    },
    getMajorByTitle() {
      this.currentPage = 1;
      this.getMajor();
    },
    async getMajor() {
      let res = await majorService.getMajorPagination({
        limit: this.limit,
        currentPage: this.currentPage,
        searchByTitle: this.searchByTitle,
        searchByDegreeType: this.searchByDegreeType
      });
      if (res) {
        this.items = res.data.data;
        this.totalPage = res.data.totalPage;
        this.totalItem = res.data.totalItem;
      }
    },
    async getContent(id) {
      this.content = '';
      let res = await majorService.getDetail(id);
      if (res) {
        this.content = res.data.content;
      }
    },
    async getMajorEdit(major) {
      let res = await majorService.getDetail(major.id);
      if (res) {
        this.$store.dispatch("setMajor", res.data);
        this.$router.push({
          name: "ResumeEdit",
          query: {
            tab: 1
          }
        });
      }
    },
    async remove(major) {
      await this.$store.dispatch("removeMajor", major);
      this.getMajor();
    }
  },
  watch: {
    searchByTopic: function(value) {
      if (value === undefined) {
        this.searchByTopic = "";
      }
      this.currentPage = 1;
      this.getMajor();
    }
  }
};
</script>
<style lang="sass">
.v-menu__content
    .v-card
        margin: 0
.radio-group .col
    padding: 0 12px
.v-input--selection-controls .v-radio>.v-label
    color: #000
    font-weight: 400
.v-input__icon
    height: 18px
</style>
